<template>
  <div class="not-found-container">
    <div>
      <img src="../assets/404.svg" />
    </div>
    <div class="error-message">
      <p>
        The link you followed may be broken, or the page may have been removed.
      </p>
    </div>
    <div class="button-container">
      <button class="download-button">
        <a :href='getLink()'>Download Uhive</a>
      </button>
    </div>
  </div>
</template>



<script>
export default {
  methods: {
    getLink() {
      let ua = navigator.userAgent;
      let isAndroid = /(android)/i.test(ua);
      if (isAndroid) {
        let intent = `${window.location.host}${window.location.pathname}`;
        return `intent://${intent}#Intent;scheme=https;package=uhiveapp.uhive.com.uhive;S.browser_fallback_url=https%3A%2F%2Fplay.google.com/store/apps/details?id=uhiveapp.uhive.com.uhive;end`;
      } else if (
        /iPad|iPhone|iPod/.test(ua) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
      ) {
        return `https://uhive.page.link/?link=https://rt.uhive.com/deeplink${encodeURIComponent('?action=OpenPost&m=' + window.location.pathname.substring(window.location.pathname.indexOf("/m") + 3))}&apn=uhiveapp.uhive.com.uhive&ibi=com.uhive.uhive&isi=1441517158&ifl=https://apps.apple.com/app/id1441517158&ipfl=https://apps.apple.com/app/id1441517158&efr=1`;
      } else {
        return "https://www.uhive.com/download";
      }
    },
  }
};
</script>



<style scoped>
.download-button a{
  color: #fff;
  text-decoration: none;
}
.not-found-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2rem;
  height: 100vh;
  width: 70%;
  margin: auto;
  text-align: center;
  font-family: SFUIDisplay;
}

.error-message {
  font-family: SFUIDisplay;
  font-size: 2rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
  color: #333;
}
.error-message p {
  color: #fff;
}
.not-found-container img {
  width: 20vh;
}

.button-container {
  width: 100%;
  text-align: center;
}
.download-button {
  color: white;
  font-weight: 600;
  font-size: 1.5rem;
  letter-spacing: 0.05rem;
  width: 15rem;
  height: 3.8rem;
  border-radius: 2rem;
  background-color: #2979fc;
  line-height: 0;
  margin-top: 1rem;
}

@media only screen and (max-height: 700px) {
  .error-message {
    font-size: 1rem;
  }
}
</style>
